import { useDispatch, useSelector } from "react-redux";
import { PrimaryButton } from "common";
import { signupSelectors } from "store/signup-slice/selectors";
import { signupActions } from "store/signup-slice/slice";

import * as S from "./styled";

export const AcceptModal = () => {
  const { isOpenAcceptModal, deletePropertyId, ownerData } = useSelector(signupSelectors);

  const dispatch = useDispatch();

  const handleCloseModal = () => {
    dispatch(signupActions.toggleAcceptModal());
  };
  const handleDeleteItem = () => {
    const body = { owner_id: ownerData?.id, property_id: deletePropertyId };
    dispatch(signupActions.deleteProperty());
    dispatch(signupActions.deletePropertyLeads(body));
    handleCloseModal();
  };

  return (
    <S.Container className={`${isOpenAcceptModal ? "active" : ""}`}>
      <S.Content className={`${isOpenAcceptModal ? "active" : ""}`}>
        <S.Question>Are you sure you want to remove this property?</S.Question>
        <PrimaryButton eventHandler={handleDeleteItem} label="yes" />
        <PrimaryButton className="no" eventHandler={handleCloseModal} label="no" />
      </S.Content>
    </S.Container>
  );
};
